import { generateId, getQueryStr } from '@/utils/helpers.js'
import { toPath } from 'best-modules/utils'

/** Administration */
const urlGetTemplateRoutingDocuments = (params = {}) => {
  const { page = 1 } = params
  return `/json/documentTemplate?page=${page}`
}

const urlCreateTemplateRoutingDocument = () => {
  return '/json/documentTemplate'
}

const urlUpdateTemplateRoutingDocument = id => {
  return `/json/documentTemplate/${id}`
}

const urlDeleteTemplateRoutingDocument = id => {
  return `/json/documentTemplate/${id}`
}

const urlCreateRouteDocument = () => {
  return '/json/documentTemplate/route'
}

const urlUpdateRouteDocument = id => {
  return `/json/documentTemplate/route/${id}`
}

const urlGetTemplateRoutingDocumentSingle = id => {
  return `/json/documentTemplate/${id}`
}

const urlDeleteTemplateRouteDocument = id => {
  return `/json/documentTemplate/route/${id}`
}
const urlCreateDocumentTemplateRouteUser = () => {
  return '/json/documentTemplate/route/user'
}

const urlDeleteDocumentTemplateRouteUser = id => {
  return `/json/documentTemplate/route/user/${id}`
}

/** Organizational Structure */
const urlCreateStaffUnitAssignment = () => '/json/orgStructure/assignment'
const urlUpdateStaffUnitAssignment = id => `/json/orgStructure/assignment/${id}`
const urlDismissStaffUnitAssignment = id =>
  `/json/orgStructure/assignment/${id}/dismiss`

const urlGetOrgDepartmentTypes = (params = {}) =>
  `/json/orgStructure/departmentType?page=${params.page || 1}`
const urlCreateOrgDepartmentType = () => '/json/orgStructure/departmentType'
const urlUpdateOrgDepartmentType = id =>
  `/json/orgStructure/departmentType/${id}`
const urlDeleteOrgDepartmentType = id =>
  `/json/orgStructure/departmentType/${id}`

const urlGetOrgPositions = (params = {}) =>
  `/json/orgStructure/position?page=${params.page || 1}`
const urlCreateOrgPosition = () => '/json/orgStructure/position'
const urlUpdateOrgPosition = id => `/json/orgStructure/position/${id}`
const urlDeleteOrgPosition = id => `/json/orgStructure/position/${id}`

const urlGetOrgStaffUnitTypes = (params = {}) =>
  `/json/orgStructure/staffUnitType?page=${params.page || 1}`
const urlCreateOrgStaffUnitType = () => '/json/orgStructure/staffUnitType'
const urlUpdateOrgStaffUnitType = id => `/json/orgStructure/staffUnitType/${id}`
const urlDeleteOrgStaffUnitType = id => `/json/orgStructure/staffUnitType/${id}`

const urlGetOrgAppointmentTypes = (params = {}) =>
  `/json/orgStructure/appointmentType?page=${params.page || 1}`
const urlCreateOrgAppointmentType = () => '/json/orgStructure/appointmentType'
const urlUpdateOrgAppointmentType = id =>
  `/json/orgStructure/appointmentType/${id}`
const urlDeleteOrgAppointmentType = id =>
  `/json/orgStructure/appointmentType/${id}`
/** Notifications */
const urlNotificationList = (page = 1) =>
  `/json/notification/system?page=${page}`
const urlNotificationRead = notificationId =>
  `/json/notification/system/markAsRead/${notificationId}`
const urlNotificationUnreadCount = () => {
  return '/json/notification/system/unreadCount'
}
const urlNotificationReadAll = () => {
  return '/json/notification/system/markAllAsRead'
}

/** File */
const baseUrl = window.location.origin
const urlMicrosoft = 'https://view.officeapps.live.com/op/embed.aspx?src=' // eslint-disable-line max-len
const urlMicrosoftPreview = filePath => {
  if (!filePath) return filePath

  return `${urlMicrosoft}${baseUrl}${toPath(filePath)}?cache=${generateId()}`
}

/* POST */
const urlUploadFiles = () => '/json/file/upload'
/* POST */
const urlDeleteFile = () => '/json/file/delete'

/** Users */
/* GET */
const urlUserBirthdaysList = (params = {}) => {
  const { filters } = params
  return `/json/user/birthdays${getQueryStr(filters, {
    ampersand: false,
  })}`
}

/* GET */
const urlCompanyStructure = query => {
  return `/json/department/getEmployeesDirectory${getQueryStr(query)}`
}
/* POST*/
const urlUserAbsenceCreate = () => '/json/user/absence/create'
/* DELETE */
const urlUserAbsenceDelete = absenceId =>
  `/json/user/absence/delete/${absenceId}`
/** Authorization */
/** Documents */
/* GET */
const urlDocumentSignatureList = query => {
  return `/json/document/signature${getQueryStr(query)}`
}
const urlDocumentSignatureSingle = (docId, absenceId) => {
  return absenceId
    ? `/json/document/signature/${docId}/${absenceId}`
    : `/json/document/signature/${docId}`
}
/* POST */
const urlDocumentSignatureCreate = () => '/json/document/signature'
/* DELETE*/
const urlDocumentSignatureDelete = documentId =>
  `/json/document/signature/${documentId}`

const urlDocumentSignatureUpdate = (docId, absenceId) => {
  return absenceId
    ? `/json/document/signature/${docId}/${absenceId}`
    : `/json/document/signature/${docId}`
}
/* POST */
const urlDocumentSignatureUserCreate = () => {
  return '/json/document/signature/user'
}
/* DELETE */
const urlDocumentSignatureUserDelete = userId => {
  return `/json/document/signature/user/${userId}`
} /* PATCH */
const urlDocumentSignatureUserSetSignature = userId => {
  return `/json/document/signature/user/setSignature/${userId}`
}
/* POST */
const urlDocumentSignatureContractorCreate = () => {
  return '/json/document/signature/contractor'
}
/* DELETE */
const urlDocumentSignatureContractorDelete = contractorId => {
  return `/json/document/signature/contractor/${contractorId}`
}
/* POST */
const urlSignatureBreak = docId => `/json/document/signature/cancel/${docId}`
const urlDocumentSendToAgree = documentId => {
  return `/json/document/signature/convertToAgreement/${documentId}`
}
/* GET */
const urlDocumentSignatureProtocol = (documentId, absenceId) => {
  return absenceId
    ? `/json/document/signature/protocol/${documentId}/${absenceId}`
    : `/json/document/signature/protocol/${documentId}`
}
/* GET */
const urlDocumentSignatureArchive = (documentId, absenceId) => {
  return absenceId
    ? `/json/document/signature/archive/${documentId}/${absenceId}`
    : `/json/document/signature/archive/${documentId}`
}
/* GET */
const urlDocumentSignatureRepack = documentId => {
  return `/json/document/signature/repack/${documentId}`
}
/* GET */
const urlGetDiiaData = documentId => {
  return `/json/document/signature/participant/diia/${documentId}`
}
const urlSignCreate = () => {
  return '/json/document/signature/participant'
}
/** Orders */
/* GET */
const urlOrderList = query => {
  return `/json/order${getQueryStr(query)}`
}
/* GET */
const urlOrderSingle = orderId => `/json/order/${orderId}`
/* POST */
const urlCreateOrder = () => '/json/order'
/* PUT */
const urlUpdateOrder = orderId => `/json/order/${orderId}`
/* DELETE */
const urlOrderDelete = orderId => `/json/order/${orderId}`
/* GET */
const urlOrderRelated = orderId => {
  return `/json/order/${orderId}/related`
}
/* GET */
const urlOrderTreeRelated = orderId => {
  return `/json/order/${orderId}/treeRelated`
}

/* PATCH */
const urlOrderUpdateDocument = orderId => {
  return `/json/order/${orderId}/document`
}
/* PATCH */
const urlOrderUpdateExtraDocument = orderId => {
  return `/json/order/${orderId}/extraDocument`
}
/* PATCH */
const urlDeactivateOrder = orderId => {
  return `/json/order/${orderId}/deactivate`
}
/* PATCH */
const urlActivateOrder = orderId => `/json/order/${orderId}/activate`
/* POST */
const urlOrderRelatedAdd = () => '/json/order/related'
/* DELETE */
const urlOrderRelatedDelete = () => '/json/order/related'
/* GET */
const urlFamiliarizationReportUser = query => {
  return `/json/printedForm/acknowledgmentUser${getQueryStr(query)}`
}
/* GET */
const urlFamiliarizationReportDepartment = query => {
  return `/json/printedForm/acknowledgmentDepartment${getQueryStr(query)}`
}

/** Protocols */
/* GET */
const urlProtocolList = query => {
  return `/json/protocol${getQueryStr(query)}`
}
/* GET */
const urlProtocolSingle = orderId => `/json/protocol/${orderId}`
/* POST */
const urlCreateProtocol = () => '/json/protocol'
/* PUT */
const urlUpdateProtocol = orderId => `/json/protocol/${orderId}`
/* DELETE */
const urlProtocolDelete = orderId => `/json/protocol/${orderId}`
/* GET */
const urlProtocolRelated = orderId => {
  return `/json/protocol/${orderId}/related`
}
/* GET */
const urlProtocolTreeRelated = orderId => {
  return `/json/protocol/${orderId}/treeRelated`
}

/* PATCH */
const urlProtocolUpdateDocument = orderId => {
  return `/json/protocol/${orderId}/document`
}
/* PATCH */
const urlProtocolUpdateExtraDocument = orderId => {
  return `/json/protocol/${orderId}/extraDocument`
}
/* PATCH */
const urlDeactivateProtocol = orderId => {
  return `/json/protocol/${orderId}/deactivate`
}
/* PATCH */
const urlActivateProtocol = orderId => `/json/protocol/${orderId}/activate`
/* POST */
const urlProtocolRelatedAdd = () => '/json/protocol/related'
/* DELETE */
const urlProtocolRelatedDelete = () => '/json/protocol/related'
/* GET */
const urlFamiliarizationList = query => {
  return `/json/orderAndProtocol${getQueryStr(query)}`
}

/** Acknowledgment */
/* GET */
const urlAcknowledgmentByEntity = (entityTypeId, entityId) =>
  `/json/acknowledgment/byEntity/${entityTypeId}/${entityId}`
/* GET */
const urlAcknowledgmentAssignmentByEntity = (entityTypeId, entityId) =>
  `/json/acknowledgment/assignment/byEntity/${entityTypeId}/${entityId}`
/* POST */
const urlAcknowledgmentAssignmentCreate = () => {
  return '/json/acknowledgment/assignment'
}
/* DELETE */
const urlAcknowledgmentAssignmentDelete = id => {
  return `/json/acknowledgment/assignment/${id}`
}
/* PATCH */
const urlAcknowledgmentAgree = () => {
  return '/json/acknowledgment/agreed'
}

/** Directory */
/* GET */
const urlAllUsers = query => `/json/list/users${getQueryStr(query)}`

/** Department */
/* GET */
const urlDepartmentList = () => '/json/department'
/* POST */
const urlDepartmentCreate = () => '/json/department'
/* PUT */
const urlDepartmentUpdate = departmentId => `/json/department/${departmentId}`
/* DELETE */
const urlDepartmentDelete = departmentId => `/json/department/${departmentId}`
/* PATCH */
const urlDepartmentSetSupervisor = userId =>
  `/json/user/department/${userId}/supervisor`
const urlDepartmentAddUser = () => '/json/user/department'
/* DELETE */
const urlDepartmentRemoveUser = userId => `/json/user/department/${userId}`

/** Correspondence */
/* GET */
const urlCorrespondenceList = query =>
  `/json/correspondence${getQueryStr(query)}`
/* GET */
const urlCorrespondenceSingle = correspondenceId =>
  `/json/correspondence/single/${correspondenceId}`
/* POST */
const urlCorrespondenceCreate = () => '/json/correspondence/create'
/* POST */
const urlCorrespondenceUpdate = correspondenceId =>
  `/json/correspondence/update/${correspondenceId}`
/* DELETE */
const urlCorrespondenceDelete = correspondenceId =>
  `/json/correspondence/delete/${correspondenceId}`
/* POST */
const urlCorrespondenceDelivered = correspondenceId =>
  `/json/correspondence/delivered/${correspondenceId}`
/* POST */
const urlCorrespondenceRelated = correspondenceId =>
  `/json/correspondence/related/${correspondenceId}`
/* POST */
const urlCorrespondenceUnrelated = correspondenceId =>
  `/json/correspondence/unrelated/${correspondenceId}`

/* POST */
const urlCorrespondenceCreateUser = () => '/json/correspondence/user/create'
const urlCorrespondenceDeleteUser = id =>
  `/json/correspondence/user/delete/${id}`

/** Client Access */
/* POST */
const urlClientAccessByDocument = documentId =>
  `/json/document/signature/${documentId}/clientAccess`
/* POST */
const urlClientAccessCreate = () => '/json/clientAccess'
/* DELETE */
const urlClientAccessDelete = clientAccessId =>
  `/json/clientAccess/${clientAccessId}`
/* GET */
const urlClientAccessSendCode = accessToken =>
  `/client/auth/route/${accessToken}`
const urlClientAccess = () => '/client/me'
/* POST */
const urlClientAccessInputCode = () => '/client/auth/inputCode'
/* GET */
const urlClientAccessDocument = () => '/client/document/signature'
const urlClientSignatureProtocol = () => {
  return '/client/document/signature/protocol'
}
/* GET */
const urlClientSignatureArchive = () => {
  return '/client/document/signature/archive'
}
const urlClientAccessGetDiiaData = () => {
  return '/client/document/signature/participant/diia'
}
const urlClientAccessCreateSign = () => {
  return '/client/document/signature/participant'
}
const urlClientAccessUploadFile = () => {
  return '/client/upload'
}
/* GET */
const urlClineAccessRepack = () => {
  return '/client/document/signature/repack'
}

/** Other */

/* GET */
const urlCommentList = (entityTypeId, entityId) => {
  return `/json/comment/byEntity/${entityTypeId}/${entityId}`
}
/* POST */
const urlCommentCreate = () => '/json/comment'
/* DELETE */
const urlCommentDelete = commentId => `/json/comment/${commentId}`

/* GET */
const urlNoteList = (entityTypeId, entityId) => {
  return `/json/note/byEntity/${entityTypeId}/${entityId}`
}
/* POST */
const urlNoteCreate = () => '/json/note'
/* DELETE */
const urlNoteDelete = noteId => `/json/note/${noteId}`

export {
  /** Administration */
  urlGetTemplateRoutingDocuments,
  urlCreateTemplateRoutingDocument,
  urlUpdateTemplateRoutingDocument,
  urlDeleteTemplateRoutingDocument,
  urlGetTemplateRoutingDocumentSingle,
  urlCreateRouteDocument,
  urlUpdateRouteDocument,
  urlDeleteTemplateRouteDocument,
  urlCreateDocumentTemplateRouteUser,
  urlDeleteDocumentTemplateRouteUser,

  /** Organizational Structure */
  urlCreateStaffUnitAssignment,
  urlUpdateStaffUnitAssignment,
  urlDismissStaffUnitAssignment,
  urlGetOrgDepartmentTypes,
  urlCreateOrgDepartmentType,
  urlUpdateOrgDepartmentType,
  urlDeleteOrgDepartmentType,
  urlGetOrgPositions,
  urlCreateOrgPosition,
  urlUpdateOrgPosition,
  urlDeleteOrgPosition,
  urlGetOrgStaffUnitTypes,
  urlCreateOrgStaffUnitType,
  urlUpdateOrgStaffUnitType,
  urlDeleteOrgStaffUnitType,
  urlGetOrgAppointmentTypes,
  urlCreateOrgAppointmentType,
  urlUpdateOrgAppointmentType,
  urlDeleteOrgAppointmentType,

  /** Notifications */
  urlNotificationList,
  urlNotificationRead,
  urlNotificationUnreadCount,
  urlNotificationReadAll,
  /** File */
  urlUploadFiles,
  urlDeleteFile,
  urlMicrosoftPreview,

  /** Users */
  urlCompanyStructure,
  urlUserAbsenceCreate,
  urlUserAbsenceDelete,
  urlUserBirthdaysList,

  /** Documents */
  urlDocumentSignatureList,
  urlDocumentSignatureSingle,
  urlDocumentSignatureCreate,
  urlDocumentSignatureDelete,
  urlDocumentSignatureUpdate,
  urlSignatureBreak,
  urlDocumentSendToAgree,
  urlDocumentSignatureProtocol,
  urlDocumentSignatureArchive,
  urlDocumentSignatureRepack,
  urlGetDiiaData,
  urlSignCreate,
  urlDocumentSignatureUserCreate,
  urlDocumentSignatureUserDelete,
  urlDocumentSignatureUserSetSignature,
  urlDocumentSignatureContractorCreate,
  urlDocumentSignatureContractorDelete,

  /** Orders */
  urlOrderList,
  urlOrderSingle,
  urlCreateOrder,
  urlUpdateOrder,
  urlOrderRelated,
  urlOrderTreeRelated,
  urlOrderUpdateDocument,
  urlOrderUpdateExtraDocument,
  urlDeactivateOrder,
  urlActivateOrder,
  urlOrderDelete,
  urlOrderRelatedAdd,
  urlOrderRelatedDelete,
  urlFamiliarizationReportUser,
  urlFamiliarizationReportDepartment,

  /** Protocol */
  urlProtocolList,
  urlProtocolSingle,
  urlCreateProtocol,
  urlUpdateProtocol,
  urlProtocolDelete,
  urlProtocolRelated,
  urlProtocolTreeRelated,
  urlProtocolUpdateDocument,
  urlProtocolUpdateExtraDocument,
  urlDeactivateProtocol,
  urlActivateProtocol,
  urlProtocolRelatedAdd,
  urlProtocolRelatedDelete,
  urlFamiliarizationList,

  /** Acknowledgment */
  urlAcknowledgmentByEntity,
  urlAcknowledgmentAssignmentByEntity,
  urlAcknowledgmentAssignmentCreate,
  urlAcknowledgmentAssignmentDelete,
  urlAcknowledgmentAgree,

  /** Directory */
  urlAllUsers,

  /** Department */
  urlDepartmentList,
  urlDepartmentCreate,
  urlDepartmentUpdate,
  urlDepartmentDelete,
  urlDepartmentSetSupervisor,
  urlDepartmentAddUser,
  urlDepartmentRemoveUser,

  /** Correspondence */
  urlCorrespondenceList,
  urlCorrespondenceSingle,
  urlCorrespondenceCreate,
  urlCorrespondenceUpdate,
  urlCorrespondenceDelete,
  urlCorrespondenceDelivered,
  urlCorrespondenceRelated,
  urlCorrespondenceUnrelated,
  urlCorrespondenceCreateUser,
  urlCorrespondenceDeleteUser,

  /** Client Access */
  urlClientAccessByDocument,
  urlClientAccessCreate,
  urlClientAccessDelete,
  urlClientAccessSendCode,
  urlClientAccess,
  urlClientAccessInputCode,
  urlClientAccessDocument,
  urlClientSignatureProtocol,
  urlClientSignatureArchive,
  urlClientAccessGetDiiaData,
  urlClientAccessCreateSign,
  urlClientAccessUploadFile,
  urlClineAccessRepack,

  /** Other */
  urlCommentList,
  urlCommentCreate,
  urlCommentDelete,
  urlNoteList,
  urlNoteCreate,
  urlNoteDelete,
}
